import React from 'react'
import axios from 'axios'
import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
	CardTitle,
	Button,
	Input
} from 'reactstrap'

import IngredientsTypesActions from '~/actions/ingredientsTypes.js'

import apiUtils from '~/helper/api.js'


export default class RecipeIngredientsTypesModalAdd extends React.Component {
	static getDefaultState() {
		return {
			btnSubmitDisabled: true,
			ingredientType: ''
		}
	}

	constructor(props) {
		super(props)

		this.state = RecipeIngredientsTypesModalAdd.getDefaultState()
	}

	setSubmitButtonStatus = () => {
		this.setState({
			btnSubmitDisabled: (
				this.state.ingredientType === ''
			)
		})
	}

	handleChange = (event) => {
		this.setState(
			{ [event.target.name]: event.target.value },
			this.setSubmitButtonStatus
		)
	}

	submit = () => {
		this.setState({ btnSubmitDisabled: true })

		axios.post(
			`${apiUtils.getApiURL()}/ingredientTypes`,
			{
				ingredientType: this.state.ingredientType,
				isActive: 1
			}
		)
			.then(
				() => {
					// clear the form
					this.setState(RecipeIngredientsTypesModalAdd.getDefaultState())

					// refresh the list
					IngredientsTypesActions.reload()
				}
			)
	}

	render() {
		const objSubmitButton = {}

		if (this.state.btnSubmitDisabled === true) {
			objSubmitButton.title = 'Enter Ingredient Type to enable this button'
		}

		return (
			<Card body inverse color="secondary">
				<CardTitle>
					Add New Ingredient Type
				</CardTitle>
				<CardBody style={{ margin: 0, padding: 0 }}>
					<Container fluid style={{ margin: 0, padding: 0 }}>
						<Row>
							<Col xs={3}>
								Ingredient Type
							</Col>
							<Col xs={9}>
								<Input
									name="ingredientType"
									value={this.state.ingredientType}
									onChange={this.handleChange}
									maxLength={32}
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								&nbsp;
							</Col>
						</Row>
						<Row>
							<Col
								xs={12}
								className="text-right"
							>
								<Button
									onClick={this.submit}
									color="success"
									disabled={this.state.btnSubmitDisabled}
									{...objSubmitButton}
								>
									Add New Ingredient Type
								</Button>
							</Col>
						</Row>
					</Container>
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredientsTypes/add.jsx